import { Turbo } from "@hotwired/turbo-rails"

const ROSTER_FRAME_ID = "workplace_team_list"

// The Team page's bulk actions all act on whatever the roster-selection controller currently
// holds, which may be "everything matching these filters" rather than a list of ticked rows.
export function rosterSelection(controller) {
  const element = controller.element.closest('[data-controller~="roster-selection"]')
    || controller.element.querySelector('[data-controller~="roster-selection"]')
    || document.querySelector('[data-controller~="roster-selection"]')

  if (!element) return null

  return controller.application.getControllerForElementAndIdentifier(element, "roster-selection")
}

// A page without a roster-selection controller (the staff company page) has only its ticked
// boxes to describe a selection with, so those are read directly. A caller that already knows the
// members it means — a single row's action — passes their ids instead.
export function selectionFormData(controller, memberIds = null) {
  const formData = new FormData()
  const selection = rosterSelection(controller)

  if (memberIds) {
    memberIds.forEach((id) => formData.append("company_user_ids[]", id))
  } else if (selection) {
    selection.appendTo(formData)
  } else {
    tickedMemberIds(controller).forEach((id) => formData.append("company_user_ids[]", id))
  }

  return formData
}

export function selectedMemberCount(controller) {
  const selection = rosterSelection(controller)
  if (selection) return selection.selectedCount()

  return tickedMemberIds(controller).length
}

function tickedMemberIds(controller) {
  return Array.from(
    controller.element.querySelectorAll('.bulk-select-checkbox:checked:not([data-bulk-select-target="selectAll"])')
  ).map((checkbox) => checkbox.value)
}

// A bulk action can change rows the browser has never rendered, so the roster is re-fetched from
// the server rather than patched in place.
export function reloadRoster(controller) {
  rosterSelection(controller)?.clear()
  Turbo.visit(window.location.href, { frame: ROSTER_FRAME_ID, action: "replace" })
}
